import { c as _c } from "react/compiler-runtime";
import { Button } from "@xefi/x-react/button";
import DOMPurify from "dompurify";
import { t } from "i18next";
import Image from "next/image";
import type { SurveyBase } from "@/models/survey";
type SurveyTakingIntroPageProps = {
  currentSurvey?: SurveyBase;
  handleMoveToNextPage?: () => void;
};
export const SurveyTakingIntroPage = t0 => {
  const $ = _c(16);
  const {
    currentSurvey,
    handleMoveToNextPage
  } = t0;
  let t1;
  if ($[0] !== currentSurvey?.media) {
    t1 = currentSurvey?.media?.find(_temp);
    $[0] = currentSurvey?.media;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const introductionPageImage = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="self-start text-lg font-bold">{t("survey.introPage")}</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== introductionPageImage) {
    t3 = introductionPageImage && <div className="w-full max-w-175 self-center @md:h-117.5"><Image src={introductionPageImage.original_url ?? ""} alt="survey image" height={470} width={700} className="h-full max-h-117.5 rounded-lg" unoptimized={true} /></div>;
    $[3] = introductionPageImage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== currentSurvey?.description) {
    t4 = currentSurvey?.description && <div dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(currentSurvey?.description || "")
    }} />;
    $[5] = currentSurvey?.description;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="[&_p]:overflow-wrap-anywhere overflow-hidden text-pretty break-words [&_a]:text-blue-500 [&_a:hover]:text-blue-600 [&_p]:break-words">{t4}</div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = t("survey.start");
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== handleMoveToNextPage) {
    t7 = <Button onClick={handleMoveToNextPage} className="self-end">{t6}</Button>;
    $[10] = handleMoveToNextPage;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t5 || $[14] !== t7) {
    t8 = <div className="flex h-full w-full flex-col items-center gap-6 overflow-y-auto px-10 py-6">{t2}<div className="flex w-full flex-1 flex-col justify-center gap-6">{t3}{t5}{t7}</div></div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp(image) {
  return image.collection_name && image.collection_name === "logo";
}